import styled from 'styled-components';
import IconButton from '../IconButton';
import { prefix } from '../../tools/settings';
export var StyledFrame = styled.div.withConfig({
  displayName: "Framestyles__StyledFrame",
  componentId: "sc-ebhmw4-0"
})(["display:grid;grid-template-columns:60px 1fr;grid-template-rows:1fr;overflow:hidden;width:100%;height:100%;background:var(--dentsu-color-n50);@media all and (-ms-high-contrast:none){display:-ms-grid;-ms-grid-columns:60px 1fr;-ms-grid-rows:1fr;}&.", "-frame--isOpen{grid-template-columns:240px 1fr;@media all and (-ms-high-contrast:none){-ms-grid-columns:240px 1fr;}.", "-frame__navigation{opacity:1;pointer-events:auto;}.", "-frame__side{box-shadow:var(--dentsu-shadow-4);}.", "-frame__toggle{&::before{opacity:1;}}}.", "-frame__navigation{pointer-events:none;opacity:0;}.", "-frame__toggle{&::before{opacity:0;}}"], prefix, prefix, prefix, prefix, prefix, prefix);
export var StyledFrameToggle = styled.div.attrs({
  className: "".concat(prefix, "-frame__toggle")
}).withConfig({
  displayName: "Framestyles__StyledFrameToggle",
  componentId: "sc-ebhmw4-1"
})(["flex:0 0 58px;display:block;position:relative;padding:0;"]);
export var StyledFrameToggleButton = styled(IconButton).withConfig({
  displayName: "Framestyles__StyledFrameToggleButton",
  componentId: "sc-ebhmw4-2"
})(["position:relative;top:8px;left:8px;"]);
export var StyledFrameNavigation = styled.div.attrs({
  className: "".concat(prefix, "-frame__navigation")
}).withConfig({
  displayName: "Framestyles__StyledFrameNavigation",
  componentId: "sc-ebhmw4-3"
})(["flex-grow:1;padding-top:8px;overflow:auto;"]);
export var StyledFrameHelpers = styled.div.withConfig({
  displayName: "Framestyles__StyledFrameHelpers",
  componentId: "sc-ebhmw4-4"
})([""]);
export var StyledFrameSide = styled.aside.withConfig({
  displayName: "Framestyles__StyledFrameSide",
  componentId: "sc-ebhmw4-5"
})(["grid-column-start:1;grid-column-end:1;position:relative;display:flex;flex-direction:column;flex-grow:1;overflow:auto;background:var(--dentsu-color-white);@media all and (-ms-high-contrast:none){-ms-grid-row:1;-ms-grid-row-span:1;-ms-grid-column:1;-ms-grid-column-span:1;}"]);
export var StyledFrameContent = styled.main.withConfig({
  displayName: "Framestyles__StyledFrameContent",
  componentId: "sc-ebhmw4-6"
})(["overflow:auto;grid-column-start:2;grid-column-end:2;@media all and (-ms-high-contrast:none){-ms-grid-row:1;-ms-grid-row-span:1;-ms-grid-column:2;-ms-grid-column-span:1;}"]);